import { Injectable, inject } from '@angular/core';
import { SettingsService } from '@service/settings.service';

@Injectable({
  providedIn: 'root',
})
export class PdfPreviewService {
  private settingsService = inject(SettingsService);


  previewByFileId(fileId: number) {
    const url = `${this.settingsService.getParsedBaseUrl()}index.jsp?redirectPreview=${encodeURIComponent(fileId)}`;
    window.open(url, 'ftfpreview', 'toolbar=no,width=950,height=725,status=yes,resizable=yes,titlebar=no');
  }
}
